import { css } from '@emotion/css';
import { xocPlate } from 'constants/global.style';
import { useEffect, useRef, useState } from 'react';

interface Props {
    timerCount: string;
    timerFinish: string;
    result: number[] | null;
    moneyWinBC: number | null
}
export default function PlateBowBC(props: Props) {
    const { timerCount, result, timerFinish, moneyWinBC } = props;

    const timerFinishRef = useRef<HTMLDivElement>(null);
    const timerRef = useRef<HTMLDivElement>(null);

    const [showHotTimer, setShowHotTimer] = useState(false);
    const [currentResult, setCurrentResult] = useState<number[]>([1, 2, 3]);
    const [stateBowl, setStateBolw] = useState<'OPEN' | 'CLOSE' | ''>('OPEN');
    const [statePlate, setStatePlate] = useState<'XOC' | 'STOP'>('STOP');
    const [showTimer, setShowTimer] = useState(false);
    const [showReslut, setShowReslut] = useState(false);

    useEffect(() => {
        if (timerFinish) {
            if (timerFinishRef.current) {
                timerFinishRef.current.style.transform = 'scale(1.25)';
                setTimeout(() => {
                    if (timerFinishRef.current) {
                        timerFinishRef.current.style.transform = 'scale(1)';
                    }
                }, 160);
            }
        }
    }, [timerFinish]);

    useEffect(() => {
        setShowHotTimer(Number(timerCount) < 10);
        if (Number(timerCount) < 10 && timerRef.current) {
            timerRef.current.style.transform = 'scale(1.25)';
            setTimeout(() => {
                if (timerRef.current) {
                    timerRef.current.style.transform = 'scale(1)';
                }
            }, 160);
        }
        if (timerCount === '00') {
            setTimeout(() => {
                setShowTimer(false);
            }, 200);
        } else {
            setShowTimer(true);
            setShowReslut(false);
        }
    }, [timerCount]);

    useEffect(() => {
        if (result) {
            setStateBolw('CLOSE');
            setTimeout(() => {
                setStatePlate('XOC');
                setShowTimer(false);
                setCurrentResult(result);
            }, 300);

            setTimeout(() => {
                setStatePlate('STOP');
                setStateBolw('OPEN');
                setShowReslut(true);
            }, 3000);
        }
    }, [result]);

    return (
        <>
            <div className={`${styles.plateBowlWrap} ${statePlate === 'XOC' ? 'xoc' : ''}`}>
                <div className={`plate-icon ${!showTimer ? 'show' : ''}`}>
                    <img className="plate-img" src={require(`assets/images/mini-bc/dia.png`)} />
                </div>
                <img className={`bowl-img ${stateBowl === 'OPEN' ? 'open' : ''}`} src={require(`assets/images/mini-bc/chen.png`)} />
                <div className={`result-wrap ${!showTimer || timerCount === '' ? 'show' : ''}`}>
                    <div className="dice-list">
                        {currentResult.map((dice, index) => (
                            <img key={index} className="dice-icon" src={require(`assets/images/mini-bc/dice-${dice}.png`)} />
                        ))}
                    </div>
                </div>
                <div className={`${styles.fxRayEffect} ${(showReslut && moneyWinBC !== 0) ? 'show' : ''}`}><img src={require(`assets/images/mini-bc/FxRay.png`)} /></div>
            </div>

            <div className={`${styles.resultWrap} ${showReslut ? 'show' : ''}`}>
                <h2><img src={require(`assets/images/mini-bc/ketqua.png`)} /></h2>
                <div className="list-icon">
                    {currentResult.map((dice, index) => (
                        <img key={index} src={require(`assets/images/mini-bc/dice-${dice}.png`)} />
                    ))}
                </div>
            </div>
        </>
    );
}

const styles = {
    fxRayEffect: css`
        left: -100px;
        top: -140px;
        width: 100%;
        height: 100%;
        position: absolute;
        width: 400px;
        display: none;
        &.show {
            display: block;
        }
        img {
            animation: rotateAnimation 2s infinite linear;
        }
    `,
    resultWrap: css`
        position: absolute;
        bottom: -300px;
        z-index: 1;
        width: 320px;
        left: 50%;
        transform: translateX(-50%);
        display: none;
        &.show {
            display: block;
        }
        h2 {
            text-align: center;
            margin: 0 0 -20px 0;
            img {
                width: 80%;
            }
        }
        .list-icon {
            background: #7A0002;
            border-radius: 30px;
            display: flex;
            padding: 10px;
            border: 2px solid #FFDE96;
            box-shadow: 0 0 5px #FFDE96;
            img {
                animation: zoomInZoomOut 0.7s infinite linear;
                margin: 0 10px;
                width: 26%;
            }
        }
    `,
    plateBowlWrap: css`
        position: relative;
        height: 100%;
        width: 100%;
        z-index: 2;
        &.xoc {
            animation: ${xocPlate} 200ms ease-out infinite;

            .bowl-img {
                width: 100%;
            }
        }
        .plate-icon {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            opacity: 0;
            width: 0;
            &.show {
                width: auto;
                opacity: 1;
            }
        }
        .bg-timer {
            &.hide {
                opacity: 1;
            }
        }
        .bowl-img {
            position: absolute;
            top: -24px;
            left: 0;
            width: 100%;
            padding: 4px;
            z-index: 4;
            transition: 0.25s ease-in;

            &.open {
                transform: translate(40px, -40px);
                opacity: 0;
                width: 0;
            }
        }
        .timer-count {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            opacity: 0;
            transition: 0.25s;
            &.show {
                opacity: 1;
            }
            .time-count {
                background: linear-gradient(180deg, rgba(255, 255, 255, 1) 25%, rgba(176, 176, 176, 1) 50%, rgba(255, 255, 255, 1) 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                font-size: 40px;
                font-weight: 700;
                transition: transform 400ms ease-in-out;
            }
            .hot-timer {
                background: linear-gradient(180deg, rgba(255, 222, 150, 1) 25%, rgba(203, 180, 129, 1) 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
            }
        }

        .result-wrap {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
            transition: 0.25s;
            z-index: 3;
            &.show {
                opacity: 1;
            }
            .dice-list {
                width: 100%;
                height: 100%;
                position: relative;
                .dice-icon {
                    width: 50px;
                    position: absolute;
                    &:nth-child(1) {
                        left: 35px;
                        top: 35px;
                    }
                    &:nth-child(2) {
                        right: 35px;
                        top: 35px;
                    }
                    &:nth-child(3) {
                        right: 71px;
                        bottom: -52px;
                    }
                }
            }
        }
        .timer-finish {
            position: absolute;
            bottom: -18px;
            width: 100%;
            text-align: center;
            color: var(--ion-color-success);
            font-weight: 700;
            transition: transform 400ms ease-in-out;
            &.hide {
                opacity: 0;
            }
        }
    `,
};